import type { FaireProductEntity } from "../../entity_types/product";

export const p_rwyazu5t5u: FaireProductEntity = {
  token: "p_rwyazu5t5u",
  type: "product",
  name: "Ornate Brass Taper Holder - Box of 4",
  brandName: "Biedermann & Sons",
  imageUrl:
    "https://cdn.faire.com/fastly/32e59851964930642c76c97a01d16529a6b1fa9f248832340e77b07f95330b05.jpeg",
  priceDollars: 22.76,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c77a4a5997e2a2f65b7946edd8690a2274a4141830e56f4341e9403480567778.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
